import { FormField } from '@/components/ui/form-field'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ServicePOCProps } from '../../types'

interface PocPaidFieldsProps {
    index: number
}

// "POC tính phí": one package total price (pre-VAT) per product; the backend
// adds VAT by product group on the invoice.
const PocPaidFields: React.FC<PocPaidFieldsProps> = ({ index }) => {
    const { t } = useTranslation('customer')
    const { control, clearErrors } = useFormContext<ServicePOCProps>()

    const isPaid = useWatch({
        control,
        name: `order.products.${index}.is_paid`,
    })

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 border border-gray-100 rounded-[8px] p-4">
            <FormField
                control={control}
                name={`order.products.${index}.is_paid`}
                type="checkbox"
                label={t('poc_is_paid')}
                bordered
                onAfterChangeValue={(value) => {
                    // The price field is hidden when unpaid, so drop its stale error
                    if (!value) clearErrors(`order.products.${index}.poc_price`)
                }}
            />
            {isPaid && (
                <FormField
                    control={control}
                    name={`order.products.${index}.poc_price`}
                    type="number"
                    label={t('poc_price')}
                    placeholder={t('poc_price')}
                    helperText={t('poc_price_helper')}
                    required
                />
            )}
        </div>
    )
}

export default PocPaidFields
